import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  drawerAwareContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "90%",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
    marginLeft: "24px",
  },
  selectorContainer: {
    width: "100%",
  },
  selectorPaper: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  tabsContainer: {
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  selectedTab: {
    p: { xs: 2, sm: 3 },
  },

  storageBarContainer: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    mb: 2,
    p: 1.5,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
  },
  storageBarTrack: {
    flex: 1,
    height: 8,
    borderRadius: 4,
    backgroundColor: "rgba(0,0,0,0.1)",
    overflow: "hidden",
  },

  toolbarRow: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    flexWrap: "wrap",
    mb: 2,
  },

  breadcrumbContainer: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    flexWrap: "wrap",
    mb: 1.5,
  },
  breadcrumbItem: {
    cursor: "pointer",
    color: colorsConstants.primaryText,
    opacity: 0.65,
    fontSize: 14,
    "&:hover": { opacity: 1, textDecoration: "underline" },
  },
  breadcrumbActive: {
    cursor: "default",
    color: colorsConstants.primaryText,
    fontWeight: 700,
    fontSize: 14,
    opacity: 1,
  },
  itemCard: {
    p: 1.5,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    cursor: "pointer",
    transition: "box-shadow 0.15s",
    "&:hover": { boxShadow: "0 2px 12px rgba(0,0,0,0.10)" },
    boxShadow: "none",
    position: "relative",
  },
  itemCardHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1,
  },
  itemName: {
    color: colorsConstants.primaryText,
    fontWeight: 600,
    fontSize: 14,
    wordBreak: "break-word",
    flex: 1,
  },
  itemMeta: {
    color: colorsConstants.primaryText,
    opacity: 0.6,
    fontSize: 12,
  },
  itemActionsRow: {
    display: "flex",
    gap: 0.5,
    mt: 0.5,
    flexWrap: "wrap",
  },
  uploadPanel: {
    position: "fixed",
    bottom: 24,
    right: 24,
    width: 300,
    zIndex: 1300,
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  uploadCard: {
    p: 1.5,
    borderRadius: 2,
    border: "1px solid rgba(0,0,0,0.1)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
  },
  requestCard: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
    height: "100%",
  },
  requestActionsContainer: {
    display: "flex",
    gap: 1,
    mt: 1.5,
    flexWrap: "wrap",
  },
  vpsCard: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
    mb: 3,
  },
  accessListItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    py: 0.5,
    px: 1,
    borderRadius: 1,
    mb: 0.5,
    border: "1px solid rgba(0,0,0,0.06)",
    backgroundColor: "rgba(0,0,0,0.02)",
  },
  modalActionsContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "space-evenly",
    mb: 1.5,
  },
  modalCancelButton: {
    color: colorsConstants.error,
  },
  emptyStateText: {
    color: colorsConstants.primaryText,
    opacity: 0.6,
    mt: 4,
    textAlign: "center",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    py: 6,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
